module.exports = __webpack_public_path__ + "img/icn_user.826c473d.svg";